import React, { Component } from 'react'
import {
  FormBox, FAIcon, WizardBox, WizardBoxItem, NumberBox, PasswordBox,
  WizardBoxSteps, TextBox, Button, Grid, GridCell
} from 'common-controls/Core/index'
import { ah, sh, compose, ReduxWrapper, QueryWrapper } from 'common-data/datahelpers'
import { BuildMessageBusEvents, log } from 'common-tools/index'
import _ from 'common-tools/LodashHelper'
import clsx from 'clsx'

export const ForgotPasswordEvents = BuildMessageBusEvents('Login.ForgotPassword')

const formName = 'ForgotPassword'
const stopAction = true
const allowAction = false

class ForgotPasswordPlain extends Component {
  constructor (props) {
    super(props)

    this.state = {
      initialValues: {},
      ForgotPasswordSteps: {
        Email: 'email',
        ConfirmEmail: 'confirmEmail',
        Phone: 'phone',
        ConfirmPhone: 'confirmPhone',
        PasswordChange: 'passwordChange',
        Confirm: 'confirm'
      },
      ForgotPasswordCompletedSteps: [],
      isPasswordValid: false
    }
  }

  componentDidMount () {
    const { clearUser, formSetFieldValue, SessionDeviceFingerPrint } = this.props

    formSetFieldValue(formName, 'DeviceFingerPrint', SessionDeviceFingerPrint)

    try {
      clearUser()
    } catch (err) {
      log.Error('Failed Clear Agency User', { Error: err })
    }
  }

  onSubmit (values) {
    const { formCheckForSubmissionErrors, showSuccess, close, ChangePassword
      , AccountLogin, setAccount, sendToURL } = this.props
    return ChangePassword(values)
      .then(({ data }) => {
        showSuccess(`Great!!! You have successfully changed your account password.`)
        AccountLogin({
          LoginId: values.Email,
          Password: values.Password,
          DeviceFingerPrint: values.DeviceFingerPrint.Id,
          DeviceUserAgent: values.DeviceFingerPrint.UserAgent
        })
          .then(({ data, extra }) => {
            setAccount(extra.Token, data)
            close([{ Type: ForgotPasswordEvents.Close }, { Type: ForgotPasswordEvents.Success }])
            sendToURL('/App')
          }).catch(formCheckForSubmissionErrors)
      })
      .catch(formCheckForSubmissionErrors)
  }

  async beforeStepAction (nextStep, previousStep, direction) {
    const { close, formDataForgotPassword,
      ValidateEmail, ValidateEmailCode, formCheckForSubmissionErrors, ValidateUsername,
      ValidatePhone, ValidatePhoneCode, formSetValidation } = this.props
    const { ForgotPasswordSteps, ForgotPasswordCompletedSteps, isPasswordValid } = this.state

    switch (nextStep) {
      case WizardBoxSteps.Done:
        return allowAction
      case WizardBoxSteps.Cancel:
        close([{ Type: ForgotPasswordEvents.Close }])
        return allowAction
    }

    if (direction === 'previous') {
      return allowAction
    }

    if (direction === 'next' && _.includes(ForgotPasswordCompletedSteps, previousStep)) {
      return allowAction
    }

    let errors = {}

    switch (previousStep) {
      case ForgotPasswordSteps.Email:
        if (!formDataForgotPassword.Email) {
          if (nextStep !== WizardBoxSteps.Cancel) {
            errors.Email = 'You must enter a valid email'
            formSetValidation(formName, errors)
            return stopAction
          }
        } else {
          try {
            await ValidateEmail({ Email: formDataForgotPassword.Email })
          } catch (err) {
            const ret = formCheckForSubmissionErrors(err, false) || {}
            formSetValidation(formName, ret.data || ret, ret.fields)
            return stopAction
          }
        }
        this.setState({
          ForgotPasswordCompletedSteps: _.uniq(_.concat(ForgotPasswordCompletedSteps, previousStep))
        })
        return allowAction

      case ForgotPasswordSteps.ConfirmEmail:
        if (!formDataForgotPassword.ConfirmEmailCode) {
          errors.ConfirmEmailCode = 'Type a valid code'
          formSetValidation(formName, errors)
          return stopAction
        } else {
          try {
            await ValidateEmailCode({
              Email: formDataForgotPassword.Email,
              EmailVerificationCode: formDataForgotPassword.ConfirmEmailCode
            })
          } catch (err) {
            const ret = formCheckForSubmissionErrors(err, false) || {}
            formSetValidation(formName, ret.data || ret, ret.fields)
            return stopAction
          }
        }
        this.setState({
          ForgotPasswordCompletedSteps: _.uniq(_.concat(ForgotPasswordCompletedSteps, previousStep))
        })
        return allowAction

      case ForgotPasswordSteps.Phone:
        if (!formDataForgotPassword.Phone) {
          errors.Phone = 'Please enter a valid phone number'
          formSetValidation(formName, errors)
          return stopAction
        } else {
          try {
            await ValidatePhone({ Email: formDataForgotPassword.Email, Phone: formDataForgotPassword.Phone })
          } catch (err) {
            const ret = formCheckForSubmissionErrors(err, false) || {}
            formSetValidation(formName, ret.data || ret, ret.fields)
            return stopAction
          }
        }
        this.setState({
          ForgotPasswordCompletedSteps: _.uniq(_.concat(ForgotPasswordCompletedSteps, previousStep))
        })
        return allowAction

      case ForgotPasswordSteps.ConfirmPhone:
        if (!formDataForgotPassword.ConfirmPhoneCode) {
          errors.ConfirmPhoneCode = 'Type a valid code'
          formSetValidation(formName, errors)
          return stopAction
        } else {
          try {
            await ValidatePhoneCode({
              Email: formDataForgotPassword.Email,
              Phone: formDataForgotPassword.Phone,
              PhoneVerificationCode: formDataForgotPassword.ConfirmPhoneCode
            })
          } catch (err) {
            const ret = formCheckForSubmissionErrors(err, false) || {}
            formSetValidation(formName, ret.data || ret, ret.fields)
            return stopAction
          }
        }
        this.setState({
          ForgotPasswordCompletedSteps: _.uniq(_.concat(ForgotPasswordCompletedSteps, previousStep))
        })
        return allowAction

      case ForgotPasswordSteps.Details:
        if (!formDataForgotPassword.Username) {
          errors.Username = 'Field cannot be empty'
          formSetValidation(formName, errors)
          return stopAction
        } else {
          try {
            await ValidateUsername({ Username: formDataForgotPassword.Username })
          } catch (err) {
            const ret = formCheckForSubmissionErrors(err, false) || {}
            formSetValidation(formName, ret.data || ret, ret.fields)
            return stopAction
          }
        }
        this.setState({
          ForgotPasswordCompletedSteps: _.uniq(_.concat(ForgotPasswordCompletedSteps, previousStep))
        })
        return allowAction

      case ForgotPasswordSteps.PasswordChange:

        if (!formDataForgotPassword.Password) {
          errors.Password = 'Password cannot be empty'
        } else if (!formDataForgotPassword.PasswordConfirm) {
          errors.PasswordConfirm = 'Password Confirmation cannot be empty'
        } else if (formDataForgotPassword.Password !== formDataForgotPassword.PasswordConfirm) {
          errors.Password = 'Password must match Password Confirmation'
          errors.PasswordConfirm = 'Password Confirmation must match Password'
        }

        if (!isPasswordValid) {
          errors.Password = 'Password does not pass the Validation Rules.'
        }

        if (!_.isEmpty(errors)) {
          formSetValidation(formName, errors)
          return stopAction
        }
        this.setState({
          ForgotPasswordCompletedSteps: _.uniq(_.concat(ForgotPasswordCompletedSteps, previousStep))
        })
        return allowAction
    }

    throw new Error(`Unexpected pervious step named ${previousStep}`)
  }

  afterStepAction (nextStep, previousStep, direction) { }

  setIsPasswordValid = (valid) => {
    this.setState({ isPasswordValid: valid })
  }

  renderEmail (readonly) {
    return (
      <React.Fragment>
        <Grid>
          <GridCell className={clsx('text-center')}>
            <h1>{`Let's help you change your password! `}<FAIcon name='smile' color='primary' /></h1>
          </GridCell>
          <GridCell className={clsx('text-center')}>
            <h2>What email did you register with?</h2>
          </GridCell>
        </Grid>
        <Grid className={clsx('align-center')}>
          <GridCell medium={4} >
            <TextBox readonly={readonly} name="Email" placeHolder="Email Address" autoComplete="email" />
          </GridCell>
        </Grid>
      </React.Fragment>
    )
  }

  renderConfirmEmail (readonly) {
    return (
      <React.Fragment>
        <Grid>
          <GridCell className={clsx('text-center')}>
            <h1>Please check your email for a new message that contains your confirmation code.</h1>
          </GridCell>
          <GridCell className={clsx('text-center')}>
            <h2>Confirm code sent to your email</h2>
          </GridCell>
        </Grid>
        <Grid className={clsx('align-center')}>
          <GridCell medium={4}>
            <TextBox readonly={readonly} name="ConfirmEmailCode" placeHolder="Confirmation Code" autoComplete="email" />
          </GridCell>
        </Grid>
      </React.Fragment>
    )
  }

  renderPhone (readonly) {
    return (
      <React.Fragment>
        <Grid>
          <GridCell className={clsx('text-center')}>
            <h1>What mobile phone number is  attached to this account?</h1>
          </GridCell>
          <GridCell className={clsx('text-center')}>
            <h2>For extra security we are going to send you a text with another confirmation code.</h2>
          </GridCell>
        </Grid>
        <Grid className={clsx('align-center')}>
          <GridCell medium={4}>
            <NumberBox readonly={readonly} type={NumberBox.FormatTypes.Phone} name="Phone" placeHolder="Phone" autoComplete="phone" />
          </GridCell>
        </Grid>
      </React.Fragment>
    )
  }

  renderConfirmPhone (readonly) {
    return (
      <React.Fragment>
        <Grid>
          <GridCell className={clsx('text-center')}>
            <h1>Confirm your mobile phone number</h1>
          </GridCell>
          <GridCell className={clsx('text-center')}>
            <h2>Please check your mobile phone for a new message that contains your second confirmation code.</h2>
          </GridCell>
        </Grid>
        <Grid className={clsx('align-center')}>
          <GridCell medium={4}>
            <TextBox readonly={readonly} name="ConfirmPhoneCode" placeHolder="Confirmation Code" />
          </GridCell>
        </Grid>
      </React.Fragment>
    )
  }

  renderPasswordChange (readonly) {
    return (
      <React.Fragment>
        <Grid>
          <GridCell className={clsx('text-center')}>
            <h1>{`All confirmed!  Let's reset your password`}<FAIcon name='smile' color='primary' /></h1>
          </GridCell>
          <GridCell className={clsx('text-center')}>
            <h2>Please enter and confirm your new password.</h2>
          </GridCell>
        </Grid>
        <Grid className={clsx('align-center')}>
          <GridCell medium={4}>
            <PasswordBox readonly={readonly} name="Password" placeHolder="Type Password" isValid={this.setIsPasswordValid}/>
          </GridCell>
        </Grid>
        <Grid className={clsx('align-center')}>
          <GridCell medium={4}>
            <TextBox readonly={readonly} type="password" name="PasswordConfirm" placeHolder="Confirm Password" />
          </GridCell>
        </Grid>
      </React.Fragment>
    )
  }

  renderConfirmation (formSubmit, loading) {
    return (
      <React.Fragment>
        <Grid>
          <GridCell className={clsx('text-center')}>
            <h1>{`You are about to reset your password. Click on the button to finish`}</h1>
          </GridCell>
        </Grid>
        <Grid className={clsx('align-center')}>
          <GridCell medium={4}>
            <Button loading={loading} color="primary" size="lg" block onClick={() => { formSubmit(formName) }}>Change My Password</Button>
          </GridCell>
        </Grid>
      </React.Fragment>
    )
  }

  render () {
    const { initialValues, ForgotPasswordSteps, ForgotPasswordCompletedSteps = [] } = this.state
    const { data = {}, formSubmit } = this.props
    const { loadingPasswordChange = false } = data

    return (
      <FormBox form={formName} simpleBody initialValues={initialValues} onSubmit={this.onSubmit} onChange={this.onChange}>
        <WizardBox afterStepAction={this.afterStepAction} beforeStepAction={this.beforeStepAction} hideNextStepButton={false}
          defaultStepId={ForgotPasswordSteps.Email} noFinalStepButton>
          <WizardBoxItem stepId={ForgotPasswordSteps.Email} icon="at" nextStepId={ForgotPasswordSteps.ConfirmEmail}>
            {this.renderEmail((_.includes(ForgotPasswordCompletedSteps, ForgotPasswordSteps.Email)))}
          </WizardBoxItem>
          <WizardBoxItem stepId={ForgotPasswordSteps.ConfirmEmail} icon="check-circle" nextStepId={ForgotPasswordSteps.Phone} previousStepId={ForgotPasswordSteps.Email}>
            {this.renderConfirmEmail((_.includes(ForgotPasswordCompletedSteps, ForgotPasswordSteps.ConfirmEmail)))}
          </WizardBoxItem>
          <WizardBoxItem stepId={ForgotPasswordSteps.Phone} icon="phone" nextStepId={ForgotPasswordSteps.ConfirmPhone} previousStepId={ForgotPasswordSteps.ConfirmEmail}>
            {this.renderPhone((_.includes(ForgotPasswordCompletedSteps, ForgotPasswordSteps.Phone)))}
          </WizardBoxItem>
          <WizardBoxItem stepId={ForgotPasswordSteps.ConfirmPhone} icon="check-circle" nextStepId={ForgotPasswordSteps.PasswordChange} previousStepId={ForgotPasswordSteps.Phone}>
            {this.renderConfirmPhone((_.includes(ForgotPasswordCompletedSteps, ForgotPasswordSteps.ConfirmPhone)))}
          </WizardBoxItem>
          <WizardBoxItem stepId={ForgotPasswordSteps.PasswordChange} icon="key" nextStepId={ForgotPasswordSteps.Confirm} previousStepId={ForgotPasswordSteps.ConfirmPhone}>
            {this.renderPasswordChange((_.includes(ForgotPasswordCompletedSteps, ForgotPasswordSteps.PasswordChange)))}
          </WizardBoxItem>
          <WizardBoxItem stepId={ForgotPasswordSteps.Confirm} icon="check-circle" nextStepId={WizardBoxSteps.Done} previousStepId={ForgotPasswordSteps.PasswordChange}>
            {this.renderConfirmation(formSubmit, loadingPasswordChange)}
          </WizardBoxItem>
        </WizardBox>
      </FormBox>
    )
  }
}

export const ForgotPassword = compose(
  ReduxWrapper([
    sh.SessionToken,
    sh.FormData(formName, 'formDataForgotPassword'),
    sh.SessionAccount,
    sh.SessionDeviceFingerPrint
  ], [
    ah.sendToURL,
    ah.setAppState,
    ah.formCheckForSubmissionErrors,
    ah.formSetValidation,
    ah.setUser,
    ah.clearUser,
    ah.setAccount,
    ah.formStopSubmit,
    ah.showInfo,
    ah.showSuccess,
    ah.formSubmit,
    ah.formSetFieldValue
  ]),
  QueryWrapper({
    key: formName,
    actions: [
      {
        url: '/Services/Security/Password/ValidateEmail',
        prop: 'ValidateEmail',
        map: 'ValidateEmailResult'
      },
      {
        url: '/Services/Security/Shared/ValidateEmailCode',
        prop: 'ValidateEmailCode',
        map: 'ValidateEmailCodeResult'
      },
      {
        url: '/Services/Security/Password/ValidatePhone',
        prop: 'ValidatePhone',
        map: 'ValidatePhoneResult'
      },
      {
        url: '/Services/Security/Shared/ValidatePhoneCode',
        prop: 'ValidatePhoneCode',
        map: 'ValidatePhoneCodeResult'
      },
      {
        url: '/Services/Security/Password/ValidateUsername',
        prop: 'ValidateUsername',
        map: 'ValidateUsernameResult'
      },
      {
        url: '/Services/Security/Password/ChangePassword',
        prop: 'ChangePassword',
        map: 'ChangePasswordResult'
      },
      {
        url: '/Services/Security/Login',
        prop: 'AccountLogin',
        map: false
      }
    ]
  })
)(ForgotPasswordPlain)

export default ForgotPassword
